import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedColaboradorInformacionComponent {
  colaborador
  desplegar = false
  editable
  elegirme
  elegirOtro
  leyenda = ''
  proyectos
  viaticoId
  yo

  constructor () {
  }

  $onInit () {
    const proyecto = this.proyectos.find((proyecto) => proyecto.id === this.colaborador.id_proyecto) || {}
    if (!this.colaborador.vinculado) {
      this.leyenda += 'Usuario no vinculado | '
    }
    if (!proyecto.total_responsables) {
      this.leyenda += 'El proyecto no tiene responsables | '
    }
    this.leyenda += this.leyenda !== '' ? 'Favor de comunicarse con Recursos Humanos EXT 304' : ''
  }

  cancelar () {
    this.desplegar = false
  }
}

module.component('viaticosSharedColaboradorInformacion', {
  controller: ViaticosSharedColaboradorInformacionComponent,
  template,
  bindings: {
    colaborador: '<',
    editable: '<',
    proyectos: '<',
    viaticoId: '<',
    yo: '<',
    elegirme: '&',
    elegirOtro: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/colaborador/informacion/component.js